import React from "react";
import { useEffect, useState } from "react";
import {
    Container,
    Title,
    Grid,
    Center,
    Text,
    Group,
    Stack,
    Image,
    Button,
    Modal,
    Box,
    AspectRatio,
    Divider,
    Flex,
    rem,
    NumberInput,
    Input,
    TextInput,
    Textarea,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { Animate } from "react-simple-animate";
import parse from "html-react-parser";
import { useViewportSize, useDisclosure } from "@mantine/hooks";
import { Link, useNavigate, useParams } from "react-router-dom";

/**
 * This view component will be rendered when visiting /pages/greet
 * when your application has been setup with inertiajs.
 */
export default function Summary(props) {
    const [quote, setQuote] = useState(props.tour);
    const { height, width } = useViewportSize();
    const params = useParams();
    const [opened, { open, close }] = useDisclosure(false);
    const navigate = useNavigate();
    const form = useForm({
        initialValues: {
            tour_id: quote.tour_id,
            email: quote.email,
            full_name: quote.name,
        },
    });
    const formSubmission = (values) => {
        // let array = Object.entries(values);
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken,
            },
            body: JSON.stringify({ values }),
        };
        fetch("/tours/createEnquiry", requestOptions)
            .then((response) => response.json())
            .then(navigate("/brochure/1/thanks"));

        //  .then(values => console.log(values));
    };

    return (
        <Animate
            play={true}
            start={{
                transform: "translateX(-100px)",
                opacity: 0.1,
            }}
            end={{ transform: "translateX(0px)", opacity: 1 }}
            easeType="ease-in"
            duration={0.3}
            delay={0}
        >
            <Center w={"100%"} py={40}>
                <Grid w={"90%"}>
                    <Grid.Col p={0} span={{ base: 12, md: 6 }}>
                        <Container
                            p={50}
                            bg={"grey.0"}
                            h={(height - 163) * 0.9}
                        >
                            <Title fz={rem(40)}>{quote.name}</Title>

                            <Text size="xl">
                                {quote.tour.nights + 1} Day Grand Tour
                            </Text>
                            <Text c="#4099BE" size="lg" fw={600}>
                                £{quote.price} per person | 23rd June - 3rd July
                            </Text>
                            <Text c="#B54937" fw={700}>
                                Pickup: {quote.pickup} | Drop Off:{" "}
                                {quote.drop_off}
                            </Text>
                            <Text c="#000000" fw={700}>
                                Pre Tour Hotel: {quote.pre_hotel} | Post Tour
                                Hotel: {quote.post_hotel}
                            </Text>
                            <Group>
                                <div className="whats-included">
                                    {parse(quote.whats_included)}
                                </div>
                            </Group>
                            <Box h={200} style={{ overflowY: "scroll" }}>
                                <Text size="sm">
                                    {quote.summary.replace(/<[^>]+>/g, "")}
                                </Text>
                            </Box>
                        </Container>
                    </Grid.Col>
                    <Grid.Col p={0} span={{ base: 12, md: 6 }}>
                        <Container bg={"grey.0"} h={(height - 163) * 0.9} p={0}>
                            <Stack h={"100%"} gap={0}>
                                <AspectRatio ratio={1080 / 720}>
                                    <Image
                                        src={`https://www.best-scottish-tours.co.uk/Plugin/Tours/assets/image/large_tpro_djSvPU.jpg`}
                                    ></Image>
                                </AspectRatio>
                                <Grid h={"100%"} m={0}>
                                    <Grid.Col
                                        span={7}
                                        bg={"purple.0"}
                                        h={"100%"}
                                    >
                                        <Link
                                            to={
                                                "/brochure/" +
                                                params.tour_id +
                                                "/thanks"
                                            }
                                            onClick={() => {
                                                const requestOptions = {
                                                    method: "POST",
                                                    headers: {
                                                        "Content-Type":
                                                            "application/json",
                                                        "X-CSRF-Token":
                                                            csrfToken,
                                                    },
                                                    body: JSON.stringify({
                                                        tour_id: params.tour_id,
                                                    }),
                                                };
                                                fetch(
                                                    "/tours/createBooking",
                                                    requestOptions
                                                )
                                                    .then((res) => res.json())
                                                    .then(
                                                        (result) => {
                                                            console.log(result);
                                                        },

                                                        (error) => {}
                                                    );
                                            }}
                                        >
                                            <Center c={"white"} h={"100%"}>
                                                <Flex
                                                    direction="column"
                                                    align="center"
                                                >
                                                    <Text
                                                        size="lg"
                                                        style={{
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        I'm happy to proceed >
                                                    </Text>

                                                    <Text>
                                                        Click here to book
                                                    </Text>
                                                </Flex>
                                            </Center>
                                        </Link>
                                    </Grid.Col>

                                    <Grid.Col span={5} onClick={open}>
                                        <Center h={"100%"}>
                                            <Text
                                                size="lg"
                                                style={{
                                                    textAlign: "center",
                                                }}
                                            >
                                                I have a question >
                                            </Text>
                                        </Center>
                                    </Grid.Col>
                                </Grid>
                            </Stack>
                        </Container>
                    </Grid.Col>
                </Grid>
                <Modal opened={opened} onClose={close} title="Enquiry" centered>
                    <form
                        onSubmit={form.onSubmit((values) => {
                            console.log(values);
                            // e.preventDefault();
                            formSubmission(values);
                        })}
                    >
                        <Input
                            type="hidden"
                            hideControls={true}
                            value={params.tour_id}
                            name="tour_id"
                        />
                        <TextInput
                            disabled={true}
                            hideControls={true}
                            value={quote.name}
                            name="full_name"
                            label="Name"
                        />
                        <TextInput
                            disabled={true}
                            hideControls={true}
                            value={quote.email}
                            name="email"
                            label="Email"
                        />

                        <NumberInput
                            label="Phone"
                            {...form.getInputProps("phone")}
                            hideControls={true}
                            type="tel"
                        ></NumberInput>
                        <Textarea
                            size="md"
                            // name="enquiry"
                            {...form.getInputProps("enquiry")}
                            label="Enquiry"
                            withAsterisk
                        ></Textarea>
                        <Button
                            mt={20}
                            onClick={() => {
                                close;
                            }}
                            type="submit"
                        >
                            Submit
                        </Button>
                    </form>
                </Modal>
            </Center>
        </Animate>
    );
}
